<template lang="pug">
div.nse-product-preview
    div.popup-review-overlay(:class="isShown ? 'active-show' :''")
    div.popup-review(:class="isShown ? 'active-show' :''")
        div.entry()
            img.img-close(:src="srcImageClose" @click="closePopup")

            template(v-if="isMobile")
                product-confirm-mobile(
                    :price="price"
                    :selected="selected"
                    :isShown="isShown"
                    :cartContext="cartContext"
                    :fields="fields"
                    :image="imagePreview"
                )
                    .confirm-bottom-bar
                        div.total-price
                            div.total {{ LANG.TOTAL }}
                            div.total(v-html="`${finalPrice}`")
                        div.button-bottom
                            button.button.btn-continue(@click="closePopup") {{ LANG.CONTINUE_EDIT }}
                            a.button.btn-checkout(v-if="cartContext.cart_url" href="#" @click="goto(cartContext.cart_url)") {{ LANG.ADD_TO_CART }}

            template(v-else)
                div#previewimage.image
                    img(:src="imagePreview")
                    div.size-name {{ sizeLabel }}
                div.summary
                    div.title(v-html="productName")

                    table(v-if="openInfo")
                        tr.row-additions(v-for="field in fields")
                            td.label-text {{ field.l }}:
                            td.label-value
                                span(v-html="field.v")

                    .confirm-bottom-bar()
                        div.total-price
                            div.total {{ LANG.TOTAL }}
                            div.total(v-html="`${finalPrice}`")
                        div.button-bottom
                            button.button.btn-continue(@click="closePopup") {{ LANG.CONTINUE_EDIT }}
                            a.button.btn-checkout(v-if="cartContext.cart_url" href="#" @click="goto(cartContext.cart_url)") {{ LANG.ADD_TO_CART }}
</template>
<style lang="scss">
.nse-product-preview {
    .text-right {
        text-align: right;
    }
    .emoji {
        height: 1.1em;
    }

    .popup-review-overlay {
		position: fixed;
		z-index: 9998;
		background-color: rgba(0, 0, 0, 0.65);
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		opacity: 0;
		visibility: hidden;
		-webkit-transition: all 0.12s;
		-moz-transition: all 0.12s;
		-ms-transition: all 0.12s;
		-o-transition: all 0.12s;
		transition: all 0.12s;

		&.active-show {
			opacity: 1;
			visibility: visible;
		}
	}

	.popup-review {
		position: fixed;
		width: 90%;
		max-width: 1200px;
		left: 0;
		top: 50%;
		right: 0;
		margin: auto;
		z-index: 9999;
		transform: translateY(-50%);
		opacity: 0;
		visibility: hidden;

		-webkit-transition: all 0.12s;
		-moz-transition: all 0.12s;
		-ms-transition: all 0.12s;
		-o-transition: all 0.12s;
		transition: all 0.12s;

		&.active-show {
			opacity: 1;
			visibility: visible;
		}

		.entry {
			background-color: #ffffff;
			padding: 20px 0;
			align-items: center;
			align-content: center;
			overflow: auto;
			max-height: 90vh;

			> * {
				flex: 1;
			}

			.size-name {
				margin-top: 15px;
				font-size: 14px;
				font-style: italic;
			}

			.image {
				text-align: center;
                padding-left: 20px;
                padding-right: 5px;
                @media (max-width: 991px) {
                    min-height: 0;
                }
				img {
                    margin-top: 30px;
					max-width: 90%;
					height: auto;
                    object-fit: contain;
					box-shadow: 0 0 10px rgb(0 0 0 / 30%);
                    max-height: 70vh;
                    @media (max-width: 991px) {
						&.no-image{
							min-height: 290px;
						}
                        display: block;
                        margin-left: auto;
                        margin-right: auto;
                        width: auto;
                        object-fit: contain;
                        box-shadow: none;
                    }
				}
			}

			.img-close {
				position: absolute;
				bottom: 100%;
				left: 100%;
				width: 22px;
				height: 22px;
                @media (max-width: 991px) {
                    left: auto;
                    right: 15px;
                    bottom : auto;
                    top: 15px;
                }
			}

			.summary {
				padding: 15px;
			}

			.title {
				font-weight: bold;
				font-size: 18px;
				margin-bottom: 15px;
			}

			.total-price {
				font-size: 1.3em;
				display: flex;
				justify-content: space-between;
				padding: 22px 0;
				margin: 15px 0 30px;
				border-top: 1px solid #e0e0e0;
				border-bottom: 1px solid #e0e0e0;

                @media (max-width: 991px) {
                    margin-top: auto;
                    padding-top: 20px;
                    padding-bottom: 20px;
                    margin-bottom: 20px;
                    font-size: 16px;
                    font-weight: bold;
                }
			}

			.row-additions {
				padding: 7px 0;
				font-size: 0.9em;
                td {
                    padding: 6px 0;
                    vertical-align: top;
                    +td {
                        padding-left: 10px;
						font-family: 'Arial';
                    }
                }
                + tr {
                    td {
                    }
                }
				> * {
					&:first-child {
						font-weight: bold;
					}

					+ * {
						padding-left: 5px;
						font-family: 'Arial';
					}
				}
			}

			.button-bottom {
				display: flex;

				.button {
					color: #000;
					text-align: center;
					padding: 15px 20px;
					border-radius: 1px;
					border: 1px solid #d8b869;
					cursor: pointer;
					text-decoration: none;
					height: 48px;
					display: flex;
					align-items: center;
					justify-content: center;
					&.btn-continue {
						background-color: #fff;
						color: #000;
					}

					&.btn-checkout{
						background-color: #d8b869;
						font-family: Noto Sans;
					}

					+ .button {
						margin-left: 15px;
					}
				}
			}
		}

        @media (max-width: 991px) {
            bottom: 0;
            transform: none;
            top: auto;
            width: 100%;
            overflow: auto;
            max-height: 100%;

            .entry {
                max-height: none;
				.image {
                	padding-right: 20px;
				}

                .summary {
                    padding-bottom: 0;
                }

                .button-bottom{
                    .button {
                        padding-top: 7px;
                        padding-bottom: 7px;
                        border-radius: 2px;
                    }
                }
            }
        }

		@media (max-width: 575px) {
			.entry {
				.button-bottom {
					.button{
						width: 50%;
					}
				}
			}
		}
	}

	@media (min-width: 991px) {
		.entry {
			display: flex;
		}
	}
}
</style>

<script>
import {computed, getCurrentInstance, watch} from "vue";
import ProductConfirmMobile from "@/components/GlobalProductConfirmMobile";
import TextParse from "@/commons/TextParse";

export default {
	name: "ProductConfirm",
    components: {ProductConfirmMobile},
    props: {
		price: {type: [Number, String]},
		selected: {
			type: Object
		},
		isShown: {
			type: Boolean,
			default: false
		},
		cartContext: {
			type: Object,
			default() {
				return {}
			}
		}
	},
	emits: ["close"],
	setup(props, {emit}) {
		const finalPrice = computed(() => {
			return props.price
		});

		const imagePreview = computed(() => {
            return props.cartContext.preview_url ? props.cartContext.preview_url : '';
		});


		const sizeLabel = computed(() => {
			return props.selected.poster_size ? props.selected.poster_size.title : "";
		});

		const productName = computed(() => {
			var out = `${props.selected.poster_style.title} - ${props.selected.poster_size.title}`
            out = decodeURI(out)

			return out;
		});

		watch(() => props.isShown, (show) => {
			if (show) {
				document.body.style.overflow = 'hidden'
			} else {
				document.body.style.overflow = 'auto'
			}
		})

        const {
            textSaying,
            textLocation,
            textCountry,
            textCity,
            textCoordinate,
            textDateTime,
            textTitle
        } = TextParse({
            selectedItems: props.selected
        });


        const fields = computed(() => {
            var LANG = getCurrentInstance().appContext.config.globalProperties.LANG;
            var tabs = [];
            if (textLocation) {
                tabs.push({
                    l: LANG.MODEL_CONFIRM_PLACE,
                    v: textLocation.value,
					id: "text_location"
                })
            }
            if (textSaying) {
                tabs.push({
                    l: LANG.MODEL_CONFIRM_MESSAGE,
                    v: textSaying.value,
					id: "text_messages"
                })
            }
            if (textTitle) {
                tabs.push({
                    l: LANG.MODEL_CONFIRM_TITLE,
                    v: textTitle.value,
					id: "text_title"
                })
            }
            if (textDateTime) {
                tabs.push({
                    l: LANG.MODEL_CONFIRM_DATE,
                    v: textDateTime.value,
					id: "text_date"
                })
            }

            if (textCoordinate) {
                tabs.push({
                    l: LANG.MODEL_CONFIRM_COORDINATES,
                    v: textCoordinate.value,
                    id: "text_coordinates_title"
                })
            }

            if (textCountry) {
                tabs.push({
                    l: LANG.MODEL_CONFIRM_TEXT_COUNTRY,
                    v: textCountry.value,
                    id: "text_city"
                })
            }

            if (textCity) {
                tabs.push({
                    l: LANG.MODEL_CONFIRM_TEXT_CITY,
                    v: textCity.value,
                    id: "text_country"
                })
            }

            return tabs.filter(tab => {
				return window.nse_setting_avaliable.indexOf(tab.id) >= 0;
			});
        });

		const srcImageClose = computed(() => {
			return window.nse_config.assets_url + "assets/image/close-popup.svg"
		});

		const closePopup = () => {
			emit('close');
		}

		const goto = (url) => {
			window.nse_app.redirect_to_add_cart = true;
			location.href = url;
		}


        const isMobile = computed(() => {
            return nse_app.isMobile
        })

        const openInfo = computed(() => {
		    if (!isMobile.value) return true;

		    return  false;
        })

		return {
			productName,
			imagePreview,
			fields,
			finalPrice,
			srcImageClose,
			closePopup,
			sizeLabel,
			goto,
            isMobile,
            openInfo
		}
	}
}
</script>
